import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=6650aa56&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=ts"
export * from "./Transaction.vue?vue&type=script&lang=ts"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=6650aa56&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6650aa56",
  null
  
)

export default component.exports